'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dGrouping$002dName$0024$0024anon$002439 from "./presto.types$-Grouping-Name$$anon$39.js";
import * as $j_presto$002etypes$0024$002dGrouping$002dName$0024$0024anon$002440 from "./presto.types$-Grouping-Name$$anon$40.js";
var $p;
/** @constructor */
function $c_Lpresto_types$GroupingName$() {
  this.c6X = null;
  this.c6Y = false;
  this.c6V = null;
  this.c6W = false;
  this.c71 = null;
  this.c72 = false;
  this.c6Z = null;
  this.c70 = false;
  this.c73 = null;
  this.c74 = false;
}
export { $c_Lpresto_types$GroupingName$ as $c_Lpresto_types$GroupingName$ };
$p = $c_Lpresto_types$GroupingName$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$GroupingName$;
/** @constructor */
function $h_Lpresto_types$GroupingName$() {
}
export { $h_Lpresto_types$GroupingName$ as $h_Lpresto_types$GroupingName$ };
$h_Lpresto_types$GroupingName$.prototype = $p;
$p.crz = (function() {
  if ((!this.c6Y)) {
    this.c6X = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.c6Y = true;
  }
  return this.c6X;
});
$p.nM = (function() {
  if ((!this.c6W)) {
    this.c6V = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a8;
    this.c6W = true;
  }
  return this.c6V;
});
$p.crO = (function() {
  if ((!this.c72)) {
    this.c71 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((x) => x)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$());
    this.c72 = true;
  }
  return this.c71;
});
$p.cHZ = (function() {
  if ((!this.c70)) {
    this.c6Z = new $j_presto$002etypes$0024$002dGrouping$002dName$0024$0024anon$002439.$c_Lpresto_types$GroupingName$$anon$39(this);
    this.c70 = true;
  }
  return this.c6Z;
});
$p.cIv = (function() {
  if ((!this.c74)) {
    this.c73 = new $j_presto$002etypes$0024$002dGrouping$002dName$0024$0024anon$002440.$c_Lpresto_types$GroupingName$$anon$40(this);
    this.c74 = true;
  }
  return this.c73;
});
var $d_Lpresto_types$GroupingName$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$GroupingName$, "presto.types$GroupingName$", ({
  a0L: 1,
  D: 1
}));
export { $d_Lpresto_types$GroupingName$ as $d_Lpresto_types$GroupingName$ };
var $n_Lpresto_types$GroupingName$;
function $m_Lpresto_types$GroupingName$() {
  if ((!$n_Lpresto_types$GroupingName$)) {
    $n_Lpresto_types$GroupingName$ = new $c_Lpresto_types$GroupingName$();
  }
  return $n_Lpresto_types$GroupingName$;
}
export { $m_Lpresto_types$GroupingName$ as $m_Lpresto_types$GroupingName$ };
//# sourceMappingURL=presto.types$-Grouping-Name$.js.map
